module.exports = __webpack_public_path__ + "media/images/pic/contact/magdalena-devault-339382cbb30878c68f5a4e756077e814.jpeg";